import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useLocalStorage } from "../../hooks";
import { dashboardState } from "../../redux/reducers/dashboardReducer";


import noEventImage from "../../assets/noEventImage.svg";
import { TwButton, TwContainer, TwMainLayout } from "../../components/tailwind";
import { clearLoadingData, loadingState, setSectionLoading } from "../../redux/reducers/loadingReducer";
import axiosInstance from "../../utils/axiosInstance";
import { getUrlForUsers } from "../../utils/confighelpers";
import AddEditLocationModal from "./AddEditLocationModal";
import LocationTile from "./LocationTile";
import { useTranslation } from "react-i18next";

export default function LocationList({ navigation, profileFor, title }) {

  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loadingReduxState = useSelector(loadingState);
  const dashboardReduxState = useSelector(dashboardState);
  const [userToken] = useLocalStorage("userToken");
  const [locationList, setLocationList] = React.useState([]);
  const [locationModalOpen, setLocationModalOpen] = React.useState(false);
  const [isEdit, setIsEdit] = React.useState(false);
  const [selectedLocationData, setSelectedLocationData] = React.useState({});

  React.useEffect(() => {
    (async () => {
      dispatch(setSectionLoading(true));
      await getListOfLocation();
      dispatch(clearLoadingData());
    })(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  const handleSessionClick = async (id, serviceData) => {
    setSelectedLocationData(serviceData)
    setIsEdit(true)
    setLocationModalOpen(true);
  };


  const getListOfLocation = async () => {
    const manageClassesConfig = {
      method: "get",
      url: `${getUrlForUsers()}listOfLocation`,
    };
    dispatch(setSectionLoading(true));
    const responce = await axiosInstance(manageClassesConfig);
    dispatch(setSectionLoading(false));
    if (responce.status === 200) {
      if (Array.isArray(responce.data.data)) {
        setLocationList(responce.data.data);
      }
    }
  };

  const renderLocation = (data) => {
    return (
      <ul className="space-y-4">
        {data.length > 0 ? (
          data.map((item, idx) => {
            const modifiedData = {
              popover: true,
              item: item,
            };
            return (<LocationTile
              {...modifiedData}
              key={idx}
              handleSessionClick={() => {
                handleSessionClick(item._id, item);
              }}
              reload={() => {
                getListOfLocation();
              }}
            />);
          })
        ) : (
          <li className={"text-black text-center"}>no services are available</li>
        )}
      </ul>
    );
  };

  return (
    <TwMainLayout
      headTitle={title}
      headActions={[
        (<TwButton
          className="sm:min-w-32"
          onClick={() => {
            setSelectedLocationData({})
            setIsEdit(false)
            setLocationModalOpen(true);
          }}
        >
          {t("inputFieldsTitle.addNewLocation")}
        </TwButton>),
      ]}
      children={<TwContainer className="">
        {locationList.length ? (<div
          className={"sm:max-w-lg w-full"}
        >
          {renderLocation(locationList)}
        </div>) : (loadingReduxState.sectionLoading !== undefined && loadingReduxState.sectionLoading === false) ? (
          <div className="flex flex-col justify-center items-center gap-5 text-center h-full">
            <img
              className={"w-40 md:w-60"}
              src={noEventImage}
              alt={""}
            />
            <div className={"text-primary text-lg font-bold mt-3"}>
              No Locations Configured
            </div>
            <div className="flex justify-center items-center w-full">
              <TwButton
                variant={"secondary"}
                onClick={() => {
                  setSelectedLocationData({})
                  setIsEdit(false)
                  setLocationModalOpen(true);
                }}
              >
                {t("inputFieldsTitle.addNewLocation")}
              </TwButton>
            </div>
          </div>
        ) : ""}

        <AddEditLocationModal
          isEdit={isEdit}
          selectedLocationData={selectedLocationData}
          open={locationModalOpen}
          handleClose={() => setLocationModalOpen(false)}
          handleUpdate={() => { setLocationModalOpen(false); getListOfLocation(); }}
        />
      </TwContainer>} />
  );
}
